import React, { ReactElement, FunctionComponent } from "react";
import { ResponsiveBar } from "@nivo/bar";
import { GraphProps } from "../../../wrappers/LoadingGraph";
import { AdsByMonthTyVsLyRecord } from "../../../redux/types/reportTypes";

type AdsByMonthTyVsLyDataRecord = {
  month: number;
  [key: string]: number;
};

const AdsByMonthTyVsLyGraph: FunctionComponent<GraphProps> = ({
  records,
}: GraphProps): ReactElement => {
  const currentYear = new Date().getFullYear();
  const data: Array<AdsByMonthTyVsLyDataRecord> = [];
  [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].forEach((month) =>
    data.push({ month, currentYear: 0, lastYear: 0 }),
  );

  records.forEach((r) => {
    const adRecord = r as AdsByMonthTyVsLyRecord;
    const month = adRecord.month;
    const dataObj = data[month - 1];
    if (adRecord.year === currentYear) dataObj[`${currentYear}`] = adRecord.total;
    else dataObj[`${currentYear - 1}`] = adRecord.total;
    data[month - 1] = dataObj;
  });

  return (
    <ResponsiveBar
      data={data}
      keys={[`${currentYear - 1}`, `${currentYear}`]}
      indexBy="month"
      animate={true}
      axisTop={null}
      axisRight={null}
      enableGridY={false}
      enableGridX={false}
      margin={{ top: 50, right: 20, bottom: 50, left: 60 }}
      colors={{ scheme: "nivo" }}
      groupMode="grouped"
      axisBottom={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: "Month",
        legendPosition: "middle",
        legendOffset: 40,
      }}
      axisLeft={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: "# Of Ads",
        legendPosition: "middle",
        legendOffset: -40,
      }}
      legends={[
        {
          dataFrom: "keys",
          anchor: "top-right",
          direction: "column",
          justify: false,
          translateX: 0,
          translateY: 0,
          itemsSpacing: 0,
          itemDirection: "left-to-right",
          itemWidth: 80,
          itemHeight: 20,
          itemOpacity: 0.75,
          symbolSize: 12,
          symbolShape: "circle",
          symbolBorderColor: "rgba(0, 0, 0, .5)",
          effects: [
            {
              on: "hover",
              style: {
                itemBackground: "rgba(0, 0, 0, .03)",
                itemOpacity: 1,
              },
            },
          ],
        },
      ]}
    />
  );
};

export default AdsByMonthTyVsLyGraph;
